'use client';

import { get as _get } from 'lodash-es';
import { useParams } from 'next/navigation';
import { useQuery } from '@apollo/client/react';
import { Formik, Form } from 'formik';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Loading from '@/components/loading';
import ErrorMessage from '@/components/error-message';
import NotFound from '@/components/not-found';
import { groupSubscribeQuery } from '@/apollo/groups';
import { useAppContext } from '@/contexts/app';
import CalendarLinks from '@/components/calendar-links';
import RadioGroupField from '@/components/forms/radio-group-field';
import MaterialLink from '@/components/material-link';

const GroupCalendarSubscribePageClient = () => {
  const { slug } = useParams();
  const { isLoggedIn } = useAppContext();

  const { data, loading, error } = useQuery(groupSubscribeQuery, {
    variables: { slug },
    ssr: false,
  });
  const group = _get(data, 'group');

  if (loading) { return <Loading />; }
  if (error) {
    return <ErrorMessage message='An error occurred while loading group.' error={error} />;
  }
  if (!group || group.found) { return <NotFound />; }

  return (
    <>
      <Typography variant="h2">Subscribe to Calendar</Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Formik
          initialValues={{
            calendarType: group.membership ? 'member' : 'public',
          }}
          onSubmit={() => {}}
        >
          {({ values }) => {
            const path = values.calendarType === 'member' ?
              `/groups/${group.slug}/calendar.ics?token=${group.membership.calendarToken}` :
              `/groups/${group.slug}/calendar.ics`;
            return (
              <Form>
                {isLoggedIn && (
                  <RadioGroupField
                    name="calendarType"
                    label="Include in Calendar Feed"
                    options={[
                      { value: 'public', label: `${group.name} – Public Events Only` },
                      { value: 'member', label: `${group.name} – Public Events and Group Member Events` },
                    ]}
                  />
                )}
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Calendar links below include {group.name} public events{values.calendarType === 'member' && ' and group member events'}.
                </Typography>
                <CalendarLinks path={path} />
              </Form>
            );
          }}
        </Formik>
      </Paper>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="body2">
          The above links are for this group only. <MaterialLink href="/calendar/subscribe">Subscribe to the full calendar</MaterialLink>
        </Typography>
      </Paper>
    </>
  );
};

export default GroupCalendarSubscribePageClient;
